import React from 'react';
import { Route, Switch } from 'react-router-dom';

import * as Investor from './index';

export const routes = [
    {
        exact: false,
        path: '/investor',
        component: Investor.InvestorEdit,
    },
];

export const InvestorRoutes = props => (
    <Switch>
        {routes.map(r => {
            const Component = r.component || React.createComponent(r.toRender);
            const routeProp = { ...r, component: undefined };
            return <Route key={r.path} {...routeProp} render={() => <Component {...props} />} />;
        })}
    </Switch>
);
export default InvestorRoutes;
